import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { User } from '@app/app/interfaces/user.model';

@Component({
  selector: 'app-initials-monogram',
  templateUrl: './initials-monogram.component.html',
  styleUrl: './initials-monogram.component.scss',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InitialsMonogramComponent {
  user = input.required<User>();
  index = input.required<number>();
  readonly colorClasses = [
    'initials-monogram-blue',
    'initials-monogram-lime',
    'initials-monogram-teal',
    'initials-monogram-purple',
    'initials-monogram-magenta',
    'initials-monogram-green',
    'initials-monogram-yellow'
  ];

  userInitials(user: User) {
    return `${user?.first.slice(0, 1).toUpperCase()}${user?.last
      .slice(0, 1)
      .toUpperCase()}`;
  }
}
